import {
  buildCallbackUrl,
  sendMagicLink,
  signInOrSignUpWithPassword,
  signInWithGoogle,
  signInWithPassword,
  signOut as signOutShared,
} from '@/lib/auth/session';
import { supabase } from '@/lib/supabase/client';

export type AuthInput = {
  email: string;
  password: string;
};

function buildKidsCallbackUrl(nextPath = '/kids/onboarding/profile') {
  return buildCallbackUrl(nextPath);
}

export async function signInParent(input: AuthInput) {
  await signInWithPassword(input);
}

export async function signUpParent(input: AuthInput & { parentName: string }) {
  await signInOrSignUpWithPassword({
    email: input.email,
    password: input.password,
  });
  const {
    data: { user },
  } = await supabase.auth.getUser();
  if (user && input.parentName.trim()) {
    await supabase.auth.updateUser({
      data: { parent_name: input.parentName.trim() },
    });
  }
}

export async function sendParentMagicLink(email: string) {
  await sendMagicLink({
    email,
    redirectTo: buildKidsCallbackUrl(),
  });
}

export async function signInParentWithGoogle() {
  await signInWithGoogle({
    redirectTo: buildKidsCallbackUrl(),
  });
}

export async function sendAdminMagicLink(email: string) {
  await sendMagicLink({
    email,
    redirectTo: buildCallbackUrl('/kids/admin'),
  });
}

export async function signInAdminWithGoogle() {
  await signInWithGoogle({
    redirectTo: buildCallbackUrl('/kids/admin'),
  });
}

export async function getCurrentParent() {
  const {
    data: { user },
    error,
  } = await supabase.auth.getUser();
  if (error) throw error;
  return user;
}

export async function signOut() {
  await signOutShared();
}
